<template>
  <div>
    <a-upload
      name="file"
      :show-upload-list="false"
      :customRequest="uploadFile"
      :before-upload="beforeUpload"
      @change="handleChange"
      accept=".ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
    >
      <a-button>
        <a-icon :type="loading ? 'loading' : 'upload'" /> 点击上传
      </a-button>
    </a-upload>
    <div v-if="fileUrl || defaultUrl" style="margin-top: 8px;">
      <a :href="fileUrl || defaultUrl" target="_blank" rel="noopener noreferrer">
        {{ displayName }}
      </a>
    </div>
  </div>
</template>

<script>
const OSS = require('ali-oss')
import OssApi from '../../../api/src/oss/api/OssApi'

const ossApi = new OssApi()

export default {
  name: 'FileUpload',
  props: {
    path: String,
    defaultUrl: String,
  },
  data() {
    return {
      loading: false,
      fileUrl: '',
      fileName: '',
    }
  },
  computed: {
    displayName() {
      if (this.fileName) return this.fileName
      const url = this.fileUrl || this.defaultUrl || ''
      if (!url) return ''
      const parts = url.split('/')
      return parts[parts.length - 1] || '已上传文件'
    },
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
      }
    },
    beforeUpload(file) {
      const name = (file.name || '').toLowerCase()
      const isPpt = name.endsWith('.ppt') || name.endsWith('.pptx')
      if (!isPpt) {
        this.$message.error('仅支持上传 PPT/PPTX 文件')
        return false
      }
      return true
    },
    async uploadFile(info) {
      try {
        const res = await ossApi.getStsAkTextbookEditor(this.path)
        const region = res.endpoint
        const fKey = region.indexOf('//') + 2
        const lKey = region.indexOf('.')
        const client = new OSS({
          region: region.substring(fKey, lKey),
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          stsToken: res.securityToken,
          bucket: res.bucketName,
        })

        const name = info.file.name || 'file'
        const ext = name.includes('.') ? name.split('.').pop() : 'ppt'
        const objectKey = `${res.url}${info.file.uid}.${ext}`

        let uploaded = false
        await client.multipartUpload(objectKey, info.file, {
          progress: (p, checkpoint) => {
            if (p === 1 && !uploaded) {
              uploaded = true
              const endpointPath = res.endpoint.split('/')
              const endpoint = endpointPath[endpointPath.length - 1]
              const url = checkpoint
                ? `https://${res.bucketName}.${endpoint}/${checkpoint.name}`
                : `https://${res.bucketName}.${endpoint}/${objectKey}`
              this.fileUrl = url
              this.fileName = name
              this.loading = false
              this.$emit('changeUri', objectKey)
            }
          },
        })
      } catch (err) {
        this.loading = false
        console.log(err)
        this.$message.error('文件上传失败')
      }
    },
  },
}
</script>

